export default __webpack_public_path__ + "static/media/megaphone.f0fd2fa3.svg";